/*
    Description: js alert msg class
    Author URI: https://destinationsalesandmarketinggroup.com/
    Author: adillice
    Version: 1.0.0
*/
class Alerts{

    // constructor
    constructor({

        // init classes
        alertClass = "alert",
        closeClass = "alert__close",
        hideClass = "--hide",
        bounceCount = 1,
        bounceLimit = 5,
        bounceOffset = -12,
        bounceSeconds = 0.1,
        scrollFadeStart = 150
    } = {}){
        
        // get alert class
        this.alertClass = alertClass;
        
        //get close class 
        this.closeClass = closeClass;

        // get hide class
        this.hide = hideClass;

        // alert DOM
        this.alert = (this.alertClass) ? document.querySelector(`.${this.alertClass}`) : null;
        
        // close DOM
        this.closeBttn = (this.closeClass) ? document.querySelector(`.${this.closeClass}`) : null;

        // how many time we want wrapper to bounce
        this.bounceLimit = bounceLimit;

        // set current bounce count
        this.bounceCount = bounceCount;

        // bounce time seconds to milliseconds
        this.bounceTime = (bounceSeconds * 1000);

        // bounce offset (in pixel)
        this.bounceOffset = bounceOffset;

        // setTimeOut var
        this.bouncing = null;

        // when the fade should start during scrolling 
        this.scrollFadeStart = scrollFadeStart;

        // setup events
        this.alertListeners();

    }

    // add event listeners
    alertListeners(){
        
        // close button event
        if(this.closeBttn) this.closeBttn.addEventListener("click", this.alertClose.bind(this));

        // do bounce
        this.alertBounce();

    }   

    // close method
    alertClose(e){
        
        // remove wrapper
        if(this.alert) this.alert.remove();

    }

    // alert bounce
    alertBounce(){

        // make sure we have the DOM element
        if(!this.alert) return;

        // set time
        const setTime = this.bounceTime; 
         
        // Loop
        while(this.bounceCount <= this.bounceLimit){

            // init down timeout
            this[`down${this.bounceCount}`] = setTimeout(() => {
                
                // set bottom
                this.alert.style.bottom = `${this.bounceOffset}px`;
            
                // clear out time
                clearTimeout(this[`down${this.bounceCount}`]);

            //setup time 
            }, this.bounceTime);

            // increment bounceTime
            this.bounceTime += setTime;

            // init up timeout
            this[`up${this.bounceCount}`] = setTimeout(() => {
                
                
                // set bottom
                this.alert.style.bottom = 0;
            
                // clear out time
                clearTimeout(this[`up${this.bounceCount}`]);

            //setup time 
            }, this.bounceTime);

            // increment bounceTime
            this.bounceTime += setTime;

            // increment count
            this.bounceCount++;

        }

    }

    // scroll
    alertScroll(e){

        // make sure we have an alert wrapper
        if(!this.alert) return;

        // init scroll offset
        const scrollValue = (window.pageYOffset - this.scrollFadeStart),

        // fadeout forumula
        fadeOut = (1 - (scrollValue/200)).toFixed(2);

        // set opacity
        this.alert.style.opacity = fadeOut;

        // remove alert if faded too much
        // (fadeOut <= 0) ? this.alert.classList.add(this.hide) : this.alert.classList.remove(this.hide);

        // check if fade is 0 or less
        if(fadeOut <= 0){

            //add hide class
            this.alert.classList.add(this.hide);

            // visible accessibility
            this.alert.setAttribute('aria-hidden', true);

        // visible
        }else{

            // remove hide class
            this.alert.classList.remove(this.hide);

            // visible accessibility
            this.alert.setAttribute('aria-hidden', false);
        
        }
        
    }

}

// export
export default Alerts;